module.exports = __webpack_public_path__ + "static/media/petropolis-rj.028d45da.jpg";